import './SkeletonText-5cf908c1.css';

var classes = {"SkeletonText":"prc-SkeletonText-SkeletonText-tW5nH","SkeletonTextWrapper":"prc-SkeletonText-SkeletonTextWrapper-3Z0sU"};

export { classes as default };
